import * as utils from '../functions/utils';
import * as messageUtils from '../functions/messageUtils';
import { IMainPhoto, IMemberTypeTitle, IValidate } from 'redhotpie-shared-lib/interfaces/IUser';

export default class Validate {
  age1?: string;
  age2?: string;
  ageTitle: string;
  comment: string;
  hasFavourited: boolean;
  hasLiked: boolean;
  isDiamond: boolean;
  isFavourite: boolean;
  isFavouriteMutual: boolean;
  isLikeMutual: boolean;
  isMatch: boolean;
  isOnline: boolean;
  itemDate: string;
  itemID?: string;
  location: string;
  mainPhoto: IMainPhoto;
  matchingInterests?: string;
  userId: string;
  memberLevel: string;
  memberType: string;
  memberTypeTitle: IMemberTypeTitle;
  userName: string;
  xmppId: string;
  isViewable: boolean;
  senderUserName: string;
  senderUserId: string;
  dateCreated: string;

  constructor() {
    this.age1 = undefined;
    this.age2 = undefined;
    this.ageTitle = '';
    this.comment = '';
    this.hasFavourited = false;
    this.hasLiked = false;
    this.isDiamond = false;
    this.isFavourite = false;
    this.isFavouriteMutual = false;
    this.isLikeMutual = false;
    this.isMatch = false;
    this.isOnline = false;
    this.itemDate = '';
    this.itemID = undefined;
    this.location = '';
    this.mainPhoto = {
      fullUrl: '',
      height: null,
      isPublic: false,
      isUserImage: false,
      photoID: null,
      thumbUrl: '',
      width: null,
    };
    this.matchingInterests = undefined;
    this.userId = '';
    this.memberLevel = '';
    this.memberType = '';
    this.memberTypeTitle = {
      abbr: '',
      plural: '',
      singular: '',
    };
    this.userName = '';
    this.xmppId = '';
    this.isViewable = true;
    this.senderUserName = '';
    this.senderUserId = '';
    this.dateCreated = '';
  }

  static mappingObject(_validate: any): Validate {
    if (_validate) {
      let validate = Object.assign(new Validate(), _validate);
      validate.age1 = _validate.Age1;
      validate.age2 = _validate.Age2;
      validate.ageTitle = _validate.AgeTitle;
      validate.comment = _validate.Comment;
      validate.hasFavourited = _validate.HasFavourited;
      validate.hasLiked = _validate.HasLiked;
      validate.isDiamond = _validate.IsDiamond;
      validate.isFavourite = _validate.IsFavourite;
      validate.isFavouriteMutual = _validate.IsFavouriteMutual;
      validate.isLikeMutual = _validate.IsLikeMutual;
      validate.isMatch = _validate.IsMatch;
      validate.isOnline = _validate.IsOnline;
      validate.itemDate = _validate.ItemDate;
      validate.itemID = _validate.ItemID;
      validate.location = _validate.Location;
      validate.mainPhoto.fullUrl = _validate.MainPhoto.FullUrl;
      validate.mainPhoto.height = _validate.MainPhoto.Height;
      validate.mainPhoto.isPublic = _validate.MainPhoto.IsPublic;
      validate.mainPhoto.isUserImage = _validate.MainPhoto.IsUserImage;
      validate.mainPhoto.photoID = _validate.MainPhoto.PhotoID;
      validate.mainPhoto.thumbUrl = _validate.MainPhoto.ThumbUrl;
      validate.mainPhoto.width = _validate.MainPhoto.Width;
      validate.matchingInterests = _validate.MatchingInterests;
      validate.userId = _validate.MemberID;
      validate.memberLevel = _validate.MemberLevel;
      validate.memberType = _validate.MemberType;
      validate.memberTypeTitle.abbr = _validate.MemberTypeTitle.Abbr;
      validate.memberTypeTitle.plural = _validate.MemberTypeTitle.Plural;
      validate.memberTypeTitle.singular = _validate.MemberTypeTitle.Singular;
      validate.userName = _validate.UserName;
      validate.xmppId = messageUtils.removePrefixAndSuffix(_validate.XMPPID);
      validate.isViewable = utils.hasOwnProperty(_validate, 'IsViewable') ? _validate.IsViewable : true;
      validate.senderUserName = _validate.SenderHandle;
      validate.senderUserId = _validate.SenderUserID;
      validate.dateCreated = _validate?.ItemDate || null;
      validate = utils.cleanObjectKeys(Object.keys(new Validate()), validate); // clean other key doesn't exist in user model

      return validate;
    }
    return new Validate();
  }

  static mappingObjects(_validates: any[]): Validate[] {
    const validates: Validate[] = [];
    _validates.forEach((_validate: any) => {
      const validate = Validate.mappingObject(_validate);
      validates.push(validate);
    });
    return validates;
  }
}
